import {
  UserPlus,
  DollarSign,
  Calendar,
  MessageCircle,
  ArrowRight,
} from "lucide-react";

const steps = [
  {
    id: 1,
    title: "Register & choose role",
    description:
      "Sign up and select Hero, Senior, or Counselor based on your expertise",
    icon: UserPlus,
    color: "text-primary",
  },
  {
    id: 2,
    title: "Set price & availability",
    description:
      "Define your rates (e.g., $50/30 min) and open time slots that work for you",
    icon: DollarSign,
    color: "text-accent",
  },
  {
    id: 3,
    title: "Students book your open slots & pay",
    description:
      "Students discover your profile and book sessions directly through our platform",
    icon: Calendar,
    color: "text-primary",
  },
  {
    id: 4,
    title: "Meet, mentor, and get paid (in future)",
    description:
      "Conduct your mentoring sessions and receive secure payments (in future) automatically",
    icon: MessageCircle,
    color: "text-accent",
  },
];

export function HowItWorksSection() {
  return (
    <section id="how-it-works" className="py-20 bg-background">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground">
            How it works
          </h2>

          {/* Desktop: Horizontal Stepper */}
          <div className="hidden md:block">
            <div className="relative">
              <div className="grid grid-cols-4 gap-8">
                {steps.map((step, index) => {
                  const IconComponent = step.icon;
                  return (
                    <div key={step.id} className="relative">
                      {/* Step Circle */}
                      <div className="relative z-10 mx-auto w-16 h-16 bg-primary rounded-full flex items-center justify-center mb-6 shadow-lg">
                        <IconComponent className="h-8 w-8 text-primary-foreground" />
                      </div>

                      {/* Arrow */}
                      {index < steps.length - 1 && (
                        <ArrowRight className="absolute top-6 -right-4 h-6 w-6 text-muted-foreground z-20" />
                      )}

                      {/* Content */}
                      <div className="text-center space-y-3">
                        <h3 className="text-lg font-semibold text-foreground">
                          {step.title}
                        </h3>
                        <p className="text-sm text-muted-foreground leading-relaxed">
                          {step.description}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Mobile: Vertical Timeline */}
          <div className="md:hidden space-y-8">
            {steps.map((step, index) => {
              const IconComponent = step.icon;
              return (
                <div
                  key={step.id}
                  className="relative flex items-start space-x-4"
                >
                  {/* Vertical Line */}
                  {index < steps.length - 1 && (
                    <div className="absolute left-8 top-16 w-0.5 h-16 bg-border"></div>
                  )}

                  {/* Step Circle */}
                  <div className="relative z-10 w-16 h-16 bg-primary rounded-full flex items-center justify-center flex-shrink-0 shadow-lg">
                    <IconComponent className="h-8 w-8 text-primary-foreground" />
                  </div>

                  {/* Content */}
                  <div className="flex-1 pt-2 space-y-2">
                    <h3 className="text-lg font-semibold text-foreground">
                      {step.title}
                    </h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="bg-muted/50 p-6 rounded-lg max-w-2xl mx-auto">
            <p className="text-base text-muted-foreground">
              <strong className="text-foreground">We handle everything:</strong>{" "}
              scheduling, reminders, and secure payments.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
